import React, {Suspense, lazy, useContext, useEffect, useState} from "react";
import Fade from "react-reveal";
import Button from "../../components/button/Button";
import Loading from "../../containers/loading/Loading";
import StyleContext from "../../contexts/StyleContext";
import {openSource, socialMediaLinks} from "../../portfolio";
import "./Project.scss";
import projectsData from "./ProjectsData";

void React;

export default function Projects() {
  const GithubRepoCard = lazy(() =>
    import("../../components/githubRepoCard/GithubRepoCard")
  );
  const FailedLoading = () => null;
  const renderLoader = () => <Loading />;
  const [repo, setrepo] = useState([]);
  // todo: remove useContex because is not supported
  const {isDark} = useContext(StyleContext);

  useEffect(() => {
    const getRepoData = () => {
      fetch("/profile.json")
        .then(result => {
          if (result.ok) {
            return result.json();
          }
          throw result;
        })
        .then(response => {
          setrepoFunction(response.data.user.pinnedItems.edges);
        })
        .catch(function (error) {
          console.error(
            `${error} (because of this error, nothing is shown in place of Projects section. Also check if Projects section has been configured)`
          );
          setrepoFunction("Error");
        });
    };
    getRepoData();
  }, []);

  function setrepoFunction(array) {
    setrepo(array);
  }
  if (
    !(typeof repo === "string" || repo instanceof String) &&
    openSource.display
  ) {
    return (
      <Suspense fallback={renderLoader()}>
        <div className="main" id="opensource">
          <h1 className="project-title">Projects</h1>
          <div className="repo-cards-div-main">
            {repo.map((v, i) => {
              if (!v) {
                console.error(
                  `Github Object for repository number : ${i} is undefined`
                );
              }
              return (
                <GithubRepoCard repo={v} key={v.node.id} isDark={isDark} />
              );
            })}
          </div>
          <Button
            text={"More Projects"}
            className="project-button"
            href={socialMediaLinks.github}
            newTab={true}
          />
          <div className="projects-main">
            {projectsData.map(project => {
              return (
                <div key={project.title}>
                  <Fade>
                    <div className="projects-body">
                      <img
                        src={project.image}
                        alt={project.title}
                        height="250"
                      />
                      <div className="projects-inner">
                        <h1 className="projects-heading">{project.title}</h1>
                        <p className="projects-para" style={{color: "#fff"}}>
                          {project.description}
                        </p>
                        <a
                          className="demo"
                          href={project.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button className="projects-btn">DEMO</button>
                        </a>
                      </div>
                    </div>
                  </Fade>
                </div>
              );
            })}
          </div>
        </div>
      </Suspense>
    );
  } else {
    return <FailedLoading />;
  }
}
